/* Presentation-only adapters. Original calculator inputs and scripts remain authoritative. */
(function () {
  'use strict';
  if (window.SavaOriginalFitEnhance) return;
  const records = new Map(), modals = new Map(), owners = new Set(), openingPositions = new WeakMap();
  let saved = null, serial = 0, scheduled = false;
  const suppressedSticky = new Map();
  const stickyAttributes = ['hidden', 'inert', 'aria-hidden'];
  function suppressSticky() {
    if (!owners.size) return;
    document.querySelectorAll('[data-sava-mobile-sticky-atc]').forEach(node => {
      if (!suppressedSticky.has(node)) suppressedSticky.set(node, {
        attrs: stickyAttributes.map(key => [key, node.getAttribute(key)]),
        styles: snapshot(node.style, ['display', 'visibility', 'pointer-events'])
      });
      node.setAttribute('hidden', ''); node.setAttribute('inert', ''); node.setAttribute('aria-hidden', 'true');
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    });
  }
  function restoreSticky() {
    suppressedSticky.forEach((state, node) => {
      state.attrs.forEach(([key, value]) => value === null ? node.removeAttribute(key) : node.setAttribute(key, value));
      restore(node.style, state.styles);
    });
    suppressedSticky.clear();
  }
  const props = ['position', 'top', 'left', 'width', 'overflow'];
  function snapshot(style, keys) { return keys.map(k => [k, style.getPropertyValue(k), style.getPropertyPriority(k)]); }
  function restore(style, values) { values.forEach(([k,v,p]) => v ? style.setProperty(k,v,p) : style.removeProperty(k)); }
  function lock(owner) {
    if (owners.has(owner)) return;
    owners.add(owner); suppressSticky(); if (saved) return;
    const beforeOpen = openingPositions.get(owner); openingPositions.delete(owner);
    saved = { x: beforeOpen ? beforeOpen.x : window.scrollX, y: beforeOpen ? beforeOpen.y : window.scrollY, body: snapshot(document.body.style,props), html: snapshot(document.documentElement.style,['overflow','overscroll-behavior','scroll-behavior']) };
    Object.entries({position:'fixed',top:`-${saved.y}px`,left:`-${saved.x}px`,width:'100%',overflow:'hidden'}).forEach(([k,v])=>document.body.style.setProperty(k,v,'important'));
    document.documentElement.style.setProperty('overflow','hidden','important');
    document.documentElement.style.setProperty('overscroll-behavior','none','important');
  }
  function unlock(owner) {
    owners.delete(owner); if (owners.size) return;
    restoreSticky(); if (!saved) return;
    const old = saved; saved = null;
    restore(document.body.style,old.body); restore(document.documentElement.style,old.html);
    document.documentElement.style.setProperty('scroll-behavior','auto','important');
    if (owner.openedBy && owner.openedBy.isConnected) owner.openedBy.focus({preventScroll:true});
    window.scrollTo(old.x,old.y);
    restore(document.documentElement.style,old.html);
  }
  // Height values are deliberately opaque: some original calculators use 510 for 5'10.
  function heightOptions(input) { return Array.from(input.options || []).filter(o=>o.value !== '').map(o=>({value:o.value,label:o.textContent.trim()})); }
  function formatHeight(text) { return text.replace(/(\d+)\s*['′]\s*(\d+)\s*(?:["″])?/, '$1′ $2″'); }
  function bindRange(input, kind) {
    const options = kind === 'height' ? heightOptions(input) : [];
    if (kind === 'height' && !options.length) return null;
    const root = input.closest('.sc-sizeguide,.size-finder');
    const anchor = input.parentElement.classList.contains('select-wrapper') ? input.parentElement : input;
    const marker = document.createComment('original-fit-input'); anchor.before(marker);
    const box = document.createElement('div'); box.className = 'sava-og-slider';
    const row = document.createElement('div'); row.className = 'sava-og-slider__row';
    const label = document.createElement('label'), output = document.createElement('output'), range = document.createElement('input');
    range.type='range'; range.id=`sava-og-range-${++serial}`; range.className='sava-og-slider__range';
    label.htmlFor=range.id; label.textContent=kind==='height'?'Height':'Weight';
    output.htmlFor=range.id; output.setAttribute('aria-live','polite');
    if (kind==='height') { range.min='0'; range.max=String(options.length-1); range.step='1'; }
    else { range.min=input.min || '80'; range.max=input.max || '400'; range.step=input.step && input.step!=='any'?input.step:'1'; }
    const details=document.createElement('details'); details.className='sava-og-slider__exact';
    const summary=document.createElement('summary'); summary.textContent='Enter exact value'; details.append(summary);
    const exactLabel=document.createElement('label'); exactLabel.htmlFor=input.id; exactLabel.textContent=kind==='height'?'Select height':'Weight (lbs)'; details.append(exactLabel,anchor);
    const oldLabel = Array.from(root.querySelectorAll('label')).find(l=>l.htmlFor===input.id && l!==exactLabel);
    const wasHidden=oldLabel ? oldLabel.hidden : null; if(oldLabel) oldLabel.hidden=true;
    row.append(label,output);box.append(row,range,details);marker.after(box);
    const sync=()=>{
      const index=kind==='height'?options.findIndex(o=>o.value===input.value):-1;
      const valid=kind==='height'?index>=0:input.value!=='' && Number.isFinite(Number(input.value));
      if(kind==='height') range.value=String(valid?index:Math.floor((options.length-1)/2));
      else range.value=valid?input.value:String(Math.min(Number(range.max),Math.max(Number(range.min),160)));
      const text=valid?(kind==='height'?formatHeight(options[index].label):`${input.value} lbs`):(kind==='height'?'Select height':'Select weight');
      output.textContent=text; range.setAttribute('aria-valuetext',text); box.dataset.selected=String(valid);
    };
    const update=()=>{
      input.value=kind==='height'?options[Number(range.value)].value:range.value;
      input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));sync();
    };
    range.addEventListener('input',update);range.addEventListener('change',update);
    // A tap on the neutral thumb is still an explicit selection, unlike initialization.
    range.addEventListener('pointerup',update);
    input.addEventListener('input',sync);input.addEventListener('change',sync);sync();
    return ()=>{range.removeEventListener('input',update);range.removeEventListener('change',update);range.removeEventListener('pointerup',update);input.removeEventListener('input',sync);input.removeEventListener('change',sync);marker.after(anchor);box.remove();marker.remove();if(oldLabel)oldLabel.hidden=wasHidden;};
  }
  function enhanceChart(root) {
    const panel=root.querySelector('[data-panel="chart"]'); if(!panel)return null;
    const existing=panel.querySelector('table');
    if(existing){
      const frame=existing.parentElement, oldClass=frame.className, oldIndex=frame.getAttribute('tabindex'), oldLabel=frame.getAttribute('aria-label');
      frame.classList.add('sava-inch-chart');frame.tabIndex=0;frame.setAttribute('aria-label','Size chart, measurements in inches. Scroll horizontally for all columns.');
      return ()=>{frame.className=oldClass;if(oldIndex===null)frame.removeAttribute('tabindex');else frame.setAttribute('tabindex',oldIndex);if(oldLabel===null)frame.removeAttribute('aria-label');else frame.setAttribute('aria-label',oldLabel);};
    }
    // Convert only the exact original card structure; unknown layouts remain untouched.
    const grid=Array.from(panel.querySelectorAll('div[style]')).find(el=>el.style.display==='grid' && el.children.length>1);
    if(!grid)return null;
    const rows=[]; let headings=null;
    for(const card of grid.children){
      if(card.children.length!==2)return null;
      const size=card.children[0].textContent.trim(), cells=[];
      for(const measurement of card.children[1].children){
        if(measurement.children.length!==2 || measurement.children[0].tagName!=='B' || measurement.children[1].tagName!=='SPAN')return null;
        cells.push({label:measurement.children[0].textContent.trim(),value:measurement.children[1].textContent.trim()});
      }
      if(!size || !cells.length)return null;
      const labels=cells.map(c=>c.label);
      if(headings && JSON.stringify(labels)!==JSON.stringify(headings))return null;
      headings=labels;rows.push({size,values:cells.map(c=>c.value)});
    }
    const frame=document.createElement('div');frame.className='sava-inch-chart';frame.tabIndex=0;frame.setAttribute('role','region');frame.setAttribute('aria-label','Size chart, measurements in inches. Scroll horizontally for all columns.');
    const table=document.createElement('table'),caption=document.createElement('caption');caption.textContent='Size chart · inches';table.append(caption);
    const head=document.createElement('thead'),tr=document.createElement('tr');
    ['Size',...headings].forEach(text=>{const cell=document.createElement('th');cell.scope='col';cell.textContent=text;tr.append(cell);});head.append(tr);table.append(head);
    const body=document.createElement('tbody');
    rows.forEach(row=>{const tr=document.createElement('tr'),th=document.createElement('th');th.scope='row';th.textContent=row.size;tr.append(th);row.values.forEach(text=>{const td=document.createElement('td');td.textContent=text;tr.append(td);});body.append(tr);});table.append(body);frame.append(table);
    grid.before(frame);const wasHidden=grid.hidden;grid.hidden=true;grid.classList.add('sava-og-original-cards');
    return ()=>{frame.remove();grid.hidden=wasHidden;grid.classList.remove('sava-og-original-cards');};
  }

  function enhanceRoot(root) {
    if(records.has(root)) return;
    const clean=[];
    const chartCleanup=enhanceChart(root);if(chartCleanup)clean.push(chartCleanup);
    const height=root.querySelector('#sc-user-height,select#height');
    const weight=root.querySelector('#sc-user-weight,input#weight');
    if(height) { const fn=bindRange(height,'height');if(fn)clean.push(fn); }
    if(weight) { const fn=bindRange(weight,'weight');if(fn)clean.push(fn); }
    if(clean.length) records.set(root,()=>clean.reverse().forEach(fn=>fn()));
  }
  function enhanceModal(modal) {
    if(modals.has(modal))return;
    const dialog=modal.querySelector('[role="dialog"]');
    const priorLabel=dialog ? dialog.getAttribute('aria-label') : null;
    const needsLabel=dialog && (!priorLabel || !priorLabel.trim());
    if(needsLabel)dialog.setAttribute('aria-label','Size guide');
    let touch=null;
    const start=e=>{if(e.touches.length===1)touch={x:e.touches[0].clientX,y:e.touches[0].clientY};else touch=null;};
    const move=e=>{
      if(!modal.hasAttribute('open') || !touch || e.touches.length!==1)return;
      const point=e.touches[0],dx=point.clientX-touch.x,dy=point.clientY-touch.y;
      touch={x:point.clientX,y:point.clientY};
      if(e.target.closest('input[type="range"]'))return;
      const horizontal=Math.abs(dx)>Math.abs(dy); let node=e.target;
      while(node && node!==modal){
        const style=getComputedStyle(node),delta=horizontal?dx:dy;
        const overflow=horizontal?style.overflowX:style.overflowY;
        const position=horizontal?node.scrollLeft:node.scrollTop;
        const max=horizontal?node.scrollWidth-node.clientWidth:node.scrollHeight-node.clientHeight;
        if(/auto|scroll/.test(overflow)&&max>1&&((delta<0&&position<max-1)||(delta>0&&position>0)))return;
        node=node.parentElement;
      }
      if(e.cancelable)e.preventDefault();
    };
    const sync=()=>modal.hasAttribute('open')?lock(modal):unlock(modal);
    const observer=new MutationObserver(sync);observer.observe(modal,{attributes:true,attributeFilter:['open']});
    modal.addEventListener('touchstart',start,{passive:true});modal.addEventListener('touchmove',move,{passive:false});sync();
    modals.set(modal,()=>{if(needsLabel){if(priorLabel===null)dialog.removeAttribute('aria-label');else dialog.setAttribute('aria-label',priorLabel);}observer.disconnect();modal.removeEventListener('touchstart',start);modal.removeEventListener('touchmove',move);unlock(modal);});
  }
  function boot(){
    scheduled=false;
    records.forEach((cleanup,node)=>{if(!node.isConnected){cleanup();records.delete(node);}});
    modals.forEach((cleanup,node)=>{if(!node.isConnected){cleanup();modals.delete(node);}});
    document.querySelectorAll('.sc-sizeguide,.size-finder').forEach(enhanceRoot);
    document.querySelectorAll('modal-dialog.size_guide_image_container').forEach(enhanceModal);
    suppressSticky();
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(boot);}}
  // Capture position before the original theme focuses its dialog.
  document.addEventListener('click',e=>{
    const opener=e.target.closest('modal-opener');
    if(!opener || !opener.querySelector('.size-guide-btn'))return;
    const selector=opener.getAttribute('data-modal');
    const modal=selector && document.querySelector(selector);
    if(modal && modal.matches('modal-dialog.size_guide_image_container'))openingPositions.set(modal,{x:window.scrollX,y:window.scrollY});
  },true);
  const observer=new MutationObserver(schedule);
  observer.observe(document.body,{childList:true,subtree:true});
  function cleanup(){scheduled=false;observer.disconnect();records.forEach(fn=>fn());records.clear();modals.forEach(fn=>fn());modals.clear();}
  document.addEventListener('shopify:section:unload',()=>{records.forEach(fn=>fn());records.clear();modals.forEach(fn=>fn());modals.clear();});
  document.addEventListener('shopify:section:load',schedule);
  window.addEventListener('pagehide',cleanup);
  window.addEventListener('pageshow',()=>{scheduled=false;observer.observe(document.body,{childList:true,subtree:true});schedule();});
  window.SavaOriginalFitEnhance={boot,cleanup,heightOptions,formatHeight,lock,unlock};
  boot();
})();
